import { apiV3Client } from './BaseRepository';

export function updateOrder(orderId, orderDetails) {
  return apiV3Client.put(`orders/${orderId}/_status`, orderDetails);
}

export function fetchOrders({ jobIds }) {
  return apiV3Client.post(`orders/_status`, { jobIds });
}
